module.exports = __webpack_public_path__ + "assets/265b4ce6b578eb0ce796ef6c3b1fff19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/channels/ro/3.png
// module id = 352
// module chunks = 1